import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-message-input-modal',
    templateUrl: './message-input-modal.component.html',
    styleUrls: ['./message-input-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageInputModalComponent implements OnInit {
    @Input() dismissFn: () => void;
    @Input() submitFn: (message: string) => void;
    @Input() title: string = 'Enter Message';
    @ViewChild('textarea', { static: true }) private textarea: ElementRef<HTMLTextAreaElement>;

    public message$ = new BehaviorSubject('');

    constructor() { }

    ngOnInit() {
        this.textarea?.nativeElement.focus();
    }

    public updateMessage(message: string) {
        this.message$.next(message);
    }

    public submitHandler() {
        const message = this.message$.value.trim();
        if (message) {
            this.submitFn(message);
        }
        this.dismissFn();
    }

    public cancelHandler() {
        this.dismissFn();
    }
}
